document.addEventListener("DOMContentLoaded", function() {
  let activeSubmenu = document.querySelector(".gr-mega-panel__item .gr-submenu");
  let activeLink = null;
  let submenuWrapper = document.querySelector('.nav__sub-wrap');
  const navSubmebu =  document.querySelector('.nav__sub');
  const header = document.querySelector('.gr-header');

  function updateSubmenuHeight() {
    if (activeSubmenu) {
      const rect = activeSubmenu.getBoundingClientRect();
      if (rect.height > 0) {
        submenuWrapper.style.height = rect.height + 42 + 'px';
      } else {
        setTimeout(updateSubmenuHeight, 50);
      }
    }
  }

  function checkAndSetHeaderBackground() {
    if (navSubmebu.classList.contains('is-left-aligned')) {
      header.classList.add('gr-header--white');
    } else {
      header.classList.remove('gr-header--white');
    }
  }

  const observer = new MutationObserver(() => {
    checkAndSetHeaderBackground();
  });

  observer.observe(navSubmebu, { attributes: true, attributeFilter: ['class'] });

  if (activeSubmenu) {
    activeSubmenu.classList.add("gr-active");
    updateSubmenuHeight();

    activeLink = activeSubmenu.previousElementSibling;
    if (activeLink && activeLink.classList.contains("gr-mega-links__link")) {
      activeLink.classList.add("gr-hover");
    }
  }

  const links = document.querySelectorAll(".gr-mega-links__link");

  links.forEach(link => {
    link.addEventListener("mouseover", function() {
      const submenu = link.nextElementSibling;

      if (submenu && submenu.classList.contains("gr-submenu")) {
        if (activeSubmenu && activeSubmenu !== submenu) {
          activeSubmenu.classList.remove("gr-active");
        }

        if (activeLink && activeLink !== link) {
          activeLink.classList.remove("gr-hover");
        }

        submenu.classList.add("gr-active");
        link.classList.add("gr-hover");

        activeSubmenu = submenu;
        activeLink = link;

        setTimeout(() => {
          updateSubmenuHeight();
        }, 0);
      }

      checkAndSetHeaderBackground();
    });
  });

  window.addEventListener("resize", function() {
    updateSubmenuHeight();
    checkAndSetHeaderBackground();
  });
});


function parallaxEffect() {
  const parallaxSections = document.querySelectorAll('.gr-parallax-section');
  
  parallaxSections.forEach(section => {
    const images = section.querySelectorAll('.gr-parallax-image, .gr-parallax-img');
    const sectionTop = section.getBoundingClientRect().top;
    const sectionHeight = section.offsetHeight;

    const scrollSpeed = 0.1;

    if (sectionTop < window.innerHeight && sectionTop + sectionHeight > 0) {
      images.forEach(image => {
        image.style.transition = 'transform 0.2s ease-out';
        image.style.transform = `translateY(${sectionTop * scrollSpeed}px)`;
      });
    }
  });
}

function initializeParallax() {
  requestAnimationFrame(() => {
  const parallaxSections = document.querySelectorAll('.gr-parallax-section');
  
  parallaxSections.forEach(section => {
    const images = section.querySelectorAll('.gr-parallax-image, .gr-parallax-img');
    const sectionTop = section.getBoundingClientRect().top;
    const scrollSpeed = 0.1;

    images.forEach(image => {
      image.style.transition = 'transform 0.2s ease-out';
      image.style.transform = `translateY(${sectionTop * scrollSpeed}px)`;
    });
  });
})
}

document.addEventListener('DOMContentLoaded', initializeParallax);
window.addEventListener('scroll', parallaxEffect);
window.addEventListener('load', () => {
  setTimeout(() => {
    initializeParallax();
    parallaxEffect();
  }, 200);
});
  
  document.addEventListener('DOMContentLoaded', function () {
    const titles = document.querySelectorAll('.gr-foot-nav-title');
  
    function toggleActiveClass(event) {
      if (window.innerWidth <= 767) {
        titles.forEach(function (title) {
          if (title !== event.target) {
            title.classList.remove('gr-foot-nav-title--active');
          }
        });
        event.target.classList.toggle('gr-foot-nav-title--active');
      }
    }
  
    titles.forEach(function (title) {
      title.addEventListener('click', toggleActiveClass);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const subnav = document.querySelector('.section--subnav');
    if (!subnav) return;
  
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim()
    ) || 0;
  
    let isSticky = false;
  
    function checkSticky() {
      const subnavRect = subnav.getBoundingClientRect();
      const scrollY = window.scrollY;
  
      if (scrollY >= subnavRect.top + scrollY - headerHeight) {
        if (!isSticky) {
          subnav.classList.add('sticky-active');
          isSticky = true;
        }
      } else {
        if (isSticky) {
          subnav.classList.remove('sticky-active');
          isSticky = false;
        }
      }
    }
  
    document.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  });
  
  

document.addEventListener("DOMContentLoaded", function () {
  const element = document.querySelector(".gr-animation-wrap");

  if (element) {
      element.style.transform = "matrix(1.05, 0, 0, 1.05, 0, 0)";
  }

  const observer = new IntersectionObserver(
      (entries) => {
          entries.forEach((entry) => {
              if (entry.isIntersecting) {
                  element.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
              }
          });
      },
      { threshold: 0.15 }
  );

  observer.observe(element);
});

const observer = new MutationObserver(() => {
  const gridListSwitches = document.querySelectorAll('[data-component="GridListSwitch"]');
  const stepNames = document.querySelectorAll('[data-component="StepName"]');

  gridListSwitches.forEach(gridListSwitch => {
    gridListSwitch.classList.add("opened");
  });

  stepNames.forEach(stepName => {
    stepName.classList.add("opened");
  });

  if (stepNames.length > 0) {
      stepNames.forEach(stepName => {
          stepName.addEventListener("click", function () {
              const parent = stepName.closest('.kitenzo-stepper-item');
              if (!parent) {
                  return;
              }

              const gridListSwitch = parent.querySelector('[data-component="GridListSwitch"]');
              if (gridListSwitch) {
                  gridListSwitch.classList.toggle("opened");
                  stepName.classList.toggle("opened");
              }
          });
      });

      observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

const requirementsObserver = new MutationObserver(() => {
  const summaryFooter = document.querySelector('.SidebarKitSummary-module__sidebar-mobile-footer');
  const requirementsBlock = document.querySelector(".SidebarKitSummary-module__sidebar-hidden-content .Collapsible-module__collapsible-container:last-child:has(.Collapsible-module__collapsible-header)");

  if (summaryFooter && requirementsBlock) {
    requirementsBlock.style.bottom = `${summaryFooter.offsetHeight}px`;
  }
});

requirementsObserver.observe(document.body, { childList: true, subtree: true });